<template>
<center>
    <div class="card card-body custom-card-style">
        <Header pageTitle="Development Tools" class="card-container"></Header>
        <div class="row">
            <div class="col-md-12">
                <base-button @click="showDuplicateUsers()" type="primary" v-b-popover.hover.right="
              'All users that are not unique and not deleted in database.'
            ">
                    <i class="tim-icons icon-bullet-list-67"></i> Show Duplicate Users
                </base-button>
                <base-button @click="showCpuAndRamStats()" type="secondary">
                    <i class="tim-icons icon-bulb-63"></i> Show CPU/RAM Stats
                </base-button>
                <base-button @click="removeDuplicateUsers()" type="danger">
                    <i class="tim-icons icon-alert-circle-exc"></i> Remove Duplicate
                    Users From Database
                </base-button>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-md-12">
                <h3>Results:</h3>
                <textarea v-model="serverResponse" class="fullWidth no-resize" disabled name="" id="" cols="30" rows="10"></textarea>
            </div>
        </div>
    </div>
</center>
</template>

<script>
import axios from "@/axios";
import Header from "@/components/App/Header.vue";

export default {
    name: "DevelopmentTools",
    data() {
        return {
            serverResponse: "",
        };
    },

    components: {
        Header,
    },
    methods: {
        showDuplicateUsers() {
            axios.get("api/developmenttools/getduplicateusers").then((response) => {
                this.serverResponse = response.data;
            });
        },
        showCpuAndRamStats() {
            axios.get("api/developmenttools/serverstatistics").then((response) => {
                this.serverResponse = response.data;
            });
        },
        removeDuplicateUsers() {
            axios.get("api/developmenttools/removeduplicateusers").then((response) => {
                this.serverResponse = response.data;
            });
        }
    },
};
</script>

<style>
</style>
